import $ from 'jquery';
import 'selectize';
import fillCountryFieldsUsingIpInfo from './util/fillCountryFieldsUsingIpInfo';

const _Forms = {
  init() {
    this.cache();
    this.events();
    this.getFormPagination();
    this.fillCountryFieldsUsingIpInfo();
  },
  fillCountryFieldsUsingIpInfo() {
    fillCountryFieldsUsingIpInfo();
  },
  cache() {
    this.$doc = $(document);
    this.$win = $(window);
    this.$html = $('html');
    this.$body = $('body');
    this.selectInit = false;
    this.queryFields = [
      'utm_medium',
      'utm_source',
      'utm_campaign',
      'utm_term',
      'utm_content',
      'utm_adgroup',
      'pcid',
      'pcn',
      'pcrid',
      'pkwid',
      'pscid'
    ];
  },
  events() {
    this.$win.on(
      'load',
      event => this.bindGFormEvents(event)
    )
    this.$doc.on(
      'click',
      '[type="submit"]',
      event => this.handleFormSubmit(event)
    );
    this.$doc.on(
      'change',
      '[type="file"]',
      event => this.handleFilePreview(event)
    )
    this.$doc.on(
      'click',
      '.ginput_container_fileupload',
      event => this.handleFilePreview(event)
    )
  },
  handleFilePreview(event) {
    const input = event.currentTarget;
    const img = $('.ginput_container_fileupload').next('img');
    if (!img.length) $('.ginput_container_fileupload').after('<img class="fileupload--preview is-hidden" src="#" />')

    if (input.files && input.files[0]) {
      const reader = new FileReader();

      reader.onload = (e) => {
        $('.fileupload--preview').removeClass('is-hidden')
        $('.fileupload--preview').attr('src', e.target.result);
      }
      reader.readAsDataURL(input.files[0]);
    }
  },
  pardotDemo($form) {
    const { queryFields } = this;
    const handler = 'https://go.singular.net/l/399622/2019-04-25/84htzn';
    let data = {}

    $form.find(':input').each(function() {
      const { name, value } = this;

      queryFields.forEach(function(_q) {
        if (_q == name) {
          data[name] = value
        }
      })

      switch(name) {
        case 'input_1':
          const value = this.value.split(' ')

          data['first_name'] = value[0]
          data['last_name'] = value[1] ? value[1] : ""
          break;
        case 'input_2':
          data['email'] = this.value
          break;
        case 'input_3':
          data['company'] = this.value
          break;
        case 'input_4':
          data['phone'] = this.value
        case 'input_8.1':
          data['GDPR'] = this.value ? 'true' : 'false'
          break;
      }
    })
    return { data, handler }
  },
  pardotContact($form) {
    const { queryFields } = this;
    const handler = 'https://go.singular.net/l/399622/2019-06-11/85qn3d';
    let data = {}

    $form.find(':input').each(function() {
      const { name, value } = this;

      queryFields.forEach(function(_q) {
        if (_q == name) {
          data[name] = value
        }
      })

      switch(name) {
        case 'input_1':
          const value = this.value.split(' ')

          data['first_name'] = value[0]
          data['last_name'] = value[1] ? value[1] : ""
          break;
        case 'input_2':
          data['email'] = this.value
          break;
        case 'input_3':
          data['phone'] = this.value
          break;
        case 'input_4':
          data['company'] = this.value
          break;
        case 'input_6':
          data['Tell us what you need'] = this.value
          break;
        case 'input_8.1':
          data['GDPR'] = this.value ? 'true' : 'false'
          break;
        case 'input_9':
          data['country'] = this.value
          break;
      }
    })
    return { data, handler }
  },
  pardotTrial($form) {
    const { queryFields } = this;
    const handler = 'https://go.singular.net/l/399622/2020-02-13/8cw4pj';
    const pardot = `${$form[0].id}_pardot`;
    const iframe = `<iframe id="${pardot}-form-handler", name="${pardot}", height="0", width="0", style="position:absolute; left:-100000px; top:-100000px" src="javascript:false;"></iframe>`;
    let hidden_form = `<form id="${pardot}-form" method="post" action=${handler}>`;
    let data = {}

    function validateEmail(email) {
      const domain_name = email.split('@')[1];
      const pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
      const isNotEmail = !pattern.test(email) || !email;

      return !( isNotEmail || INVALID_DOMAINS.includes(domain_name) );

    }

    $form.find(':input').each(function() {
      const { name, value } = this;

      queryFields.forEach(function(_q) {
        if (_q == name) {
          data[name] = value
        }
      })

      switch(name) {
        case 'input_1':
          data['email'] = this.value
          break;
      }
    })

    if (!validateEmail(data['email'])) return false

    // Insert GTM data layer event after the create account form validation
    // to use in Google Tag Manager. 3/16/20
    // Updated to include email - 3/23/20
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'CreateAccountFormSubmit',
      'formEmail': data['email']
    });

    for (const [name, value] of Object.entries(data)) {

      hidden_form += `<input type="hidden" name="${name}" value="${value}" />`;

    }

    hidden_form += '</form>';

    $('body').append(hidden_form);
    $(`#${pardot}-form`).submit();

    return false
  },
  pardotSubscribe($form) {
    const { queryFields } = this;
    const handler = 'https://go.singular.net/l/399622/2019-06-11/85qn4z';
    let data = {}

    $form.find(':input').each(function() {
      const { name, value } = this;

      queryFields.forEach(function(_q) {
        if (_q == name) {
          data[name] = value
        }
      })

      switch(name) {
        case 'input_1':
          data['email'] = this.value
          break;
      }
    })
    return { data, handler }
  },
  pardotReports($form) {
    const { queryFields } = this;
    const id = $form.attr('id');
    let handler = '';
    let data = {}

    switch(id) {
      case 'gform_6':
        handler = 'https://go.singular.net/l/399622/2019-06-18/85t4k6'
        break;
      case 'gform_7':
        handler = 'https://go.singular.net/l/399622/2019-06-19/85zf2j'
        break;
      case 'gform_8':
        handler = 'https://go.singular.net/l/399622/2019-06-19/85zf4d'
        break;
      case 'gform_9':
        handler = 'https://go.singular.net/l/399622/2019-06-19/85zf5j'
        break;
      case 'gform_10':
        handler = 'https://go.singular.net/l/399622/2019-06-19/85zg7d'
        break;
    }

    $form.find(':input').each(function() {
      const { name, value } = this;

      queryFields.forEach(function(_q) {
        if (_q == name) {
          data[name] = value
        }
      })

      switch(name) {
        case 'input_6':
          const value = this.value.split(' ')

          data['first_name'] = value[0]
          data['last_name'] = value[1] ? value[1] : " "
          break;
        case 'input_9':
          data['company'] = this.value
          break;
        case 'input_7':
          data['email'] = this.value
          break;
        case 'input_8.1':
          data['GDPR'] = this.value ? 'true' : 'false'
          break;
      }
    })
    return { data, handler }
  },
  handleFormSubmit(event) {
    const $form = $(event.currentTarget).closest('form')
    const isSubscribe = $form.attr('id') == 'gform_4' || $form.attr('id') == 'gform_5';
    const isReport = $form.attr('id') == 'gform_6' || $form.attr('id') == 'gform_7' || $form.attr('id') == 'gform_8' || $form.attr('id') == 'gform_9' || $form.attr('id') == 'gform_10';
    const pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
    let config = {};

    if ( $form.attr('id') == 'gform_1' )
      config = this.pardotDemo($form)
    if ( $form.attr('id') == 'gform_2' )
      config = this.pardotContact($form)
    if ( $form.attr('id') == 'gform_13' )
      config = this.pardotTrial($form)
    if ( $form.attr('id') == 'gform_4' )
      config = this.pardotSubscribe($form)
    if ( isSubscribe )
      config = this.pardotSubscribe($form)
    if ( isReport )
      config = this.pardotReports($form)

    if (!$.isEmptyObject(config)) {
      let { handler, data } = config
      let isNotEmail = !pattern.test(data.email) || !data.email;

      !isNotEmail && $.ajax({
        type: "POST",
        url: handler,
        data: data,
        success: success,
        dataType: "jsonp"
      });

    }

    const success = function(res) {
      console.info(res)
    }
  },
  bindGFormEvents(event) {
    const self = this;
    const { selectify } = self;
    let emailFieldValue;

    jQuery(document).on('gform_post_render', function(e, id, curr) {

      if (id == 4 || id == 5 ) {

        window.mg_form_copy = {
          node: jQuery(`#gform_wrapper_${id}`).parent().html(),
          id
        }

      }

      if ( $('.gform_validation_error').length ) {
        $("body, html").animate({ scrollTop: $(`.gform_validation_error`).offset().top - 125 }, "slow");
      }

    })

    jQuery(document).on('gform_page_loaded', function(e, id, curr) { if (id == 3) {
      let placeholderOption = $('select[multiple] option')[0];

      $(placeholderOption).attr('selected', 'selected')

      selectify(self)


      $("body, html").animate({ scrollTop: $('.js-multi-progress').offset().top - 85 }, "slow");

      $('.multi-progress-step').each(function() {
        if (curr == $(this).data('step')) {
          $(this).addClass('is-active')
        }
      })

    } })

    // Using gform_input_change hook to get email address value to be able to push to dataLayer
    gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
      if (formId == 2) {
        emailFieldValue = $('#input_2_2').val();
      }
    }, 10 );

    jQuery(document).on('gform_confirmation_loaded', function(e, id) {
      const close_button = $(`
          <svg class="close-form" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 100.1 100.1" style="enable-background:new 0 0 100.1 100.1;" xml:space="preserve">
          <style type="text/css">
            .st0{fill:#FFFFFF;}
          </style>
          <g id="Layer_2">
            <g id="all_icons">
              <g id="Layer_1-2">
                <path class="st0" d="M96.6,100.1c-0.9,0-1.8-0.3-2.5-1L1,6c-1.4-1.4-1.4-3.6,0-5s3.6-1.4,5,0l93.1,93.2c1.4,1.4,1.4,3.6,0,4.9
                  c0,0,0,0,0,0C98.4,99.8,97.6,100.1,96.6,100.1z"/>
                <path class="st0" d="M3.5,100.1c-0.9,0-1.8-0.4-2.5-1c-1.4-1.4-1.4-3.6,0-4.9c0,0,0,0,0,0L94.2,1c1.4-1.4,3.6-1.4,5,0
                  c1.4,1.4,1.4,3.6,0,5L6,99.1C5.3,99.8,4.4,100.1,3.5,100.1z"/>
              </g>
            </g>
          </g>
          </svg>
      `);
      if (window.mg_form_copy) {

        close_button.click(function() {

          $(`#gform_confirmation_wrapper_${window.mg_form_copy.id}`).replaceWith( window.mg_form_copy.node )
          $('.gform_ajax_spinner').hide()

        })

        $('.gform_confirmation_message').append(close_button)
      }

      if (id == 4 || id == 5 ) {

        $('body, html').scrollTop ( $(`#gform_confirmation_wrapper_${id}`).offset().top - 140 );

      } else {
        close_button.click(function() {
          $('.form-confirmation-message').removeClass( 'is-shown' )
        })

        $('.gform_confirmation_message').append(close_button)

        $('.form-confirmation-message').html( $('.gform_confirmation_message') );
        $('.form-confirmation-message').addClass( 'is-shown' )
      }

      if (id == 3) {

        $("body, html").animate({ scrollTop: 0 }, "slow");
        $('.multi-progress').hide()

      }

      if (id == 2) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'ContactUsSubmitted',
          'email': emailFieldValue
        });
      }

      if ( $('.blog__form.sticky').length ) {
        $('.blog__form.sticky').each(function(evt) {
          if ( $(this).find('.gform_confirmation_message').length ) {
            const parentColumnTitle = $(this).find('.blog__form--title').closest('.grid__column');
            const parentColumnForm = $(this).find('.gform_confirmation_message').closest('.grid__column');

            parentColumnTitle.remove()
            parentColumnForm.removeClass('u-size-1of2--md')

            if ( $('.blog__form.sticky .close-form').length ) {
              $('.blog__form.sticky .close-form').hide()
            }

          }
        })
      }

    });

  },
  selectify(self) {
    let { selectInit } = self;

    window.$selects = $('select:not(.select-default)');

    const options = {
      plugins: ['remove_button'],
      delimiter: ',',
      persist: false,
      create: function(input) {
          return {
              value: input,
              text: input
          }
      },
      onInitialize: function() {
        this.$control_input.attr('readonly', true);
      },
      onFocus: function(value, isOnInitialize) {
        const sel = this;
        let placeholderOption = null;

        $('.selectize-input .item').each(function() {
          let value = $(this).text();
              value = value.substr(value.length - 1) == '×' ? value.slice(0,value.length - 1) : value;

          if (sel.items[0] == value) placeholderOption = this
        })

        if (placeholderOption && $(placeholderOption).text().includes('Select')) {
          $(placeholderOption).find('.remove').click()
        }
      }
    }
    window.$selects.selectize(options);

  },
  deSelectMulti(e) {

    const $control = window.$selects[0].selectize;
    $control.refreshItems();
    $control.refreshOptions();
    $control.advanceSelection(1, e);
  },
  getFormPagination() {
    const { get_form_pagination } = window

    if (get_form_pagination) {
      let html = ''


      for ( var i = 0; i < get_form_pagination.length; i++ ) {
        const page = get_form_pagination[i];
        const _class = i == 0 ? 'is-active' : '';
        let template = `
        <div data-step="${i+1}" class="multi-progress-step ${_class}">
          <span class="step--number">${i+1}</span>
          <span class="step--label">${page}</span>
        </div>
        `
        html += template
      }

      $('.js-multi-progress').append(html)
    }
  }
};

_Forms.init();
